<template>
  <GameLobby :game-type="gameType" />
</template>

<script>
  import GameLobby from '@/components/lobby/GameLobby';

  export default {
    name: 'GameLobbyView',

    components: {
      GameLobby,
    },

    computed: {
      gameType() {
        return this.$route?.meta?.gameType;
      },
    },
  };
</script>
